export const getErrorMessage = (error: any) => {
  if (error.response) {
    return JSON.parse(error.response).message;
  }
  return error.message;
};
